'use strict';

import { values, each } from 'lodash';

/**
 * @name Collection
 * @desc - Collection Class to help in the creation of Collections. Typically this will be extended to
                  support a consistent API for handling collections.
 * @property {Object} _index - internal store of all models
 */
export default class Collection {
  /**
   *
   * @param {Object} model - the model the collection will use
   */
  constructor(model) {
    this._index = {};
    this.model = model;
  }

  /**
   *
   * @desc returns all models in collection or a single model by id
   * @param {String} id
   * @returns {Object|Array<Object>}
   */
  get(id) {
    if (id) {
      return this._index[id];
    }
    return values(this._index);
  }

  /**
   * @desc sets an array of objects to the internal index
   * @param {Array<Object>} data
   */
  set(data) {
    if (!Array.isArray(data)) {
      throw new Error('[Collection] Set takes an array of objects');
    }
    each(data, datum => {
      let model = new this.model(datum);
      this._index[model.id] = model;
    });
  }

  /**
   *
   * @desc adds an object to the collection
   * @param {Object} datum
   */
  add(datum) {
    this._index[datum.id] = datum;
  }
}